<mat-card appearance="outlined" class="container">
  @if (!customer) {
  <mat-card-content>
    <app-customer-selection (customerSelected)="onCustomerSelected($event)"
     />
  </mat-card-content>
  } @else {
  <div class="questionnaire-right-panel column">
    <p style="color: #2c2c2c; font-size: 1.2em" i18n="@@selectedCustomer">
      Selected customer:
    </p>
    <app-customer-card [customer]="customer"
      (clearSelection)="clearCustomer()"
     />
    <br />
    <app-statuses-selector (selectedStatus)="selectedStatus($event)"
     />
  </div>
  @if (status !== null && customer !== null) {
  <div class="questionnaire-field">
    @for (question of questionnaireFields; track question) {
    <div>
      <div class="app-survey-block row" style="justify-content: space-between">
        <div class="column">
          <span style="font-size: 15px; display: block">{{
            question.title
          }}</span>
          <span class="row" style="font-size: 10px">
            <span i18n="@@type">Type</span>
            <p>:</p>
            {{ ControlType[question.type] }}
          </span>
        </div>
        <mat-icon (click)="removeField(question)"> remove </mat-icon>
      </div>
    </div>
    } @if (createNewMode) {
    <form [formGroup]="newFieldForm">
      <div class="column">
        <div class="row space_between">
          <mat-form-field>
            <input
              matInput
              formControlName="tag"
              placeholder="Question header"
              i18n-placeholder
            />
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              formControlName="title"
              placeholder="The content of the question"
              i18n-placeholder
            />
          </mat-form-field>
          <button
            matButton="elevated"
            style="margin: 5px"
            (click)="disableCreatingMode()"
          >
            <span i18n="@@cancel">Cancel</span>
          </button>
        </div>
        <div class="row space_between">
          <mat-form-field>
            <mat-label i18n="@@formtype">Select field type</mat-label>
            <mat-select formControlName="type">
              <mat-select-trigger class="app-type-trigger">
                @switch (newFieldForm.controls.type.value) {
                  @case (ControlType.TEXT) {
                    <mat-icon>short_text</mat-icon>
                    <span i18n>Text</span>
                  }
                  @case (ControlType.DATETIME) {
                    <mat-icon>schedule</mat-icon>
                    <span i18n>Date / Time</span>
                  }
                  @case (ControlType.DROPDOWN) {
                    <mat-icon>arrow_drop_down_circle</mat-icon>
                    <span i18n>List</span>
                  }
                  @case (ControlType.BOOLEAN) {
                    <mat-icon>check_box</mat-icon>
                    <span i18n>YES/NO</span>
                  }
                }
              </mat-select-trigger>
              <mat-option [value]="ControlType.TEXT" class="app-type-option">
                <mat-icon>short_text</mat-icon>
                <span i18n>Text</span>
              </mat-option>
              <mat-option [value]="ControlType.DATETIME" class="app-type-option">
                <mat-icon>schedule</mat-icon>
                <span i18n>Date / Time</span>
              </mat-option>
              <mat-option [value]="ControlType.DROPDOWN" class="app-type-option">
                <mat-icon>arrow_drop_down_circle</mat-icon>
                <span i18n>List</span>
              </mat-option>
              <mat-option [value]="ControlType.BOOLEAN" class="app-type-option">
                <mat-icon>check_box</mat-icon>
                <span i18n>YES/NO</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label i18n="@@required">Is required ?</mat-label>
            <mat-select formControlName="required">
              <mat-option [value]="false">
                <span i18n>No</span>
              </mat-option>
              <mat-option [value]="true">
                <span i18n>Yes</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>
              <span i18n>Select sort</span>
            </mat-label>
            <input
              type="number"
              matInput
              name="sort"
              placeholder="Sort"
              formControlName="sort"
            />
          </mat-form-field>
        </div>
        @if (newFieldForm.controls.type.value === ControlType.DROPDOWN) {
        <div class="row space_between">
          <div class="row start">
            <mat-form-field>
              <mat-label i18n>Add option</mat-label>
              <input matInput formControlName="dropdownValue" />
            </mat-form-field>
            <mat-icon (click)="saveDropdownOption()">add_circle</mat-icon>
          </div>
          <div class="row">
            <div class="column">
              <div i18n="@@options">Options:</div>
              @for (val of dropdownValues; track val) {
              <div>{{ val }}</div>
              }
            </div>
          </div>
        </div>
        }
        <div class="row">
          <button
            matButton="elevated"
            style="margin: 5px"
            (click)="saveQuestion()"
            [disabled]="!newFieldForm.valid"
          >
            <span i18n>Save Question</span>
          </button>
        </div>
      </div>
    </form>
    }
    <div class="row" style="margin-top: auto">
      <button
        matButton="elevated"
        (click)="saveQuestionnaire()"
        style="margin: 5px"
      >
        <span i18n>Save</span>
      </button>
      <button
        matButton="elevated"
        (click)="enableCreateMode()"
        style="margin: 5px"
      >
        <span i18n>Add new</span>
      </button>
    </div>
  </div>
  } }
</mat-card>
